import { getCookie, removeCookie, setCookie } from "../Share/Func/Cookie";

function useCookieStorage() {
  const getValue = (key, defaultValue = null) => {
    try {
      const item = getCookie(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.error(error);
      return defaultValue;
    }
  };

  const setValue = (key, value) => {
    try {
      setCookie(key, JSON.stringify(value));
    } catch (error) {
      console.error(error);
    }
  };

  const removeValue = (key) => {
    removeCookie(key);
  };

  return { getValue, setValue, removeValue };
}

export default useCookieStorage;
